import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import { selectAllFilterPreferences } from '../slice'
import { loadFilterPreferences } from '../api'

export const useLoadFilterPreferencesOnMount = (authenticated: boolean) => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setLoading(true)
        await dispatch(loadFilterPreferences())

        if (mounted) {
          setLoading(false)
        }
      } catch {
        if (mounted) {
          setLoading(false)
        }
      }
    }

    authenticated ? execute() : setLoading(false)

    return () => {
      mounted = false
    }
  }, [dispatch, authenticated])

  return { loading, prefs }
}
